import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card, F0TagStatus } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { ElementPreview } from 'modules/forms/components/preview/ElementPreview'
import { Element } from 'modules/forms/lib/Element'
import { Form } from 'modules/forms/lib/Form'
import { SectionElement } from 'modules/forms/lib/elements/SectionElement'

interface FormResponsesInlineProps {
  form: Form
  showElementName?: boolean
  titleSize?: 'default' | 'small'
}

const renderFeedbackTag = (element: Element) => {
  if (!element.hasCorrectAnswer) {
    return null
  }
  const isCorrect = element.answer?.isCorrect
  return (
    <F0TagStatus
      text={
        isCorrect
          ? i18n.t('trainings.content.consumer.quiz.questions.correct')
          : i18n.t('trainings.content.consumer.quiz.questions.incorrect')
      }
      variant={isCorrect ? 'positive' : 'critical'}
    />
  )
}

const FormResponsesInline: React.FC<FormResponsesInlineProps> = ({
  form,
  showElementName = true,
  titleSize = 'default',
}) => {
  return (
    <Box gap="s24">
      {form.elements.map((element: Element) => {
        if (element instanceof SectionElement) {
          return (
            <Box key={element.uuid} gap="s8">
              <Box gap="s8">
                <Text size="300" weight="bold" color="textPrimary">
                  {element.label}
                </Text>
                {element.description && (
                  <Text size="200" color="textSecondary">
                    {element.description}
                  </Text>
                )}
              </Box>

              <Box gap="s8">
                {element.elements.map((child: Element) => (
                  <Box key={child.uuid} gap="s8">
                    <Box flexDirection="row" justifyContent="flexEnd">
                      {renderFeedbackTag(child)}
                    </Box>
                    <F0Card>
                      <ElementPreview
                        element={child}
                        mode="response_without_score"
                        showElementName={showElementName}
                        titleSize={titleSize}
                      />
                    </F0Card>
                  </Box>
                ))}
              </Box>
            </Box>
          )
        }

        return (
          <Box key={element.uuid} gap="s8">
            <Box flexDirection="row" justifyContent="flexEnd">
              {renderFeedbackTag(element)}
            </Box>
            <F0Card>
              <ElementPreview
                element={element}
                mode="response_without_score"
                showElementName={showElementName}
                titleSize={titleSize}
              />
            </F0Card>
          </Box>
        )
      })}
    </Box>
  )
}

export default FormResponsesInline
